import { restClient } from '../client';

export type NotificationPreferences = {
  userId: string;
  appointmentEmail: boolean;
  appointmentSms: boolean;
  createdAt: string;
  updatedAt: string;
};

export type NotificationPreferencesResponse = {
  data: NotificationPreferences;
};

export type UpdateNotificationPreferencesInput = {
  appointment_email?: boolean;
  appointment_sms?: boolean;
};

export const getNotificationPreferences = () => {
  return restClient.request<NotificationPreferencesResponse>(
    '/api/v1/notification_preferences',
    { method: 'GET' }
  );
};

export const patchNotificationPreferences = (input: UpdateNotificationPreferencesInput) => {
  return restClient.request<NotificationPreferencesResponse>(
    '/api/v1/notification_preferences',
    {
      method: 'PATCH',
      data: input,
    }
  );
};
